<template>
  <div class="cria-dicas">
    <h1 class="title text-uppercase font-weight-bold">Criar Medidas</h1>
    <hr class="linha-amarela" />
    <div class="form-group">
      <label for="nome">Nome</label>
      <input
        type="text"
        class="form-control input-form"
        id="nome"
        v-model="medida.nome"
        placeholder="Nome da medida"
      />
    </div>
    <div class="form-group">
      <label for="descricao">Descrição</label>
      <input
        type="text"
        class="form-control input-form"
        id="descricao"
        v-model="medida.descricao"
        placeholder="Descrição da medida"
      />
    </div>
    <div class="form-group">
      <div class="btn btn-success" @click="madeMeasures()">Criar</div>
      <div class="btn btn-voltar-dicas" @click="backList()">Voltar</div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import makeToast from '../../mixins/makeToast';

export default {
  name: 'cria-medidas',
  mixins: [makeToast],
  data: () => ({
    medida: {
      nome: null,
      descricao: null,
    },
  }),
  created() {
    this.$store.dispatch('loadCidades');
  },
  computed: {
    ...mapGetters([
      'getTipoNotification',
      'getNotification',
      'getInformacaoUpload',
    ]),
    ...mapState({
      dadosUsuario: (state) => state.dadosUsuario,
      cidades: (state) => state.cidades,
    }),
  },
  methods: {
    madeMeasures() {
      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('insertTipoMedida', this.medida)
        .then(() => {
          this.makeToast('Sucesso', 'Inserido com sucesso', 'success');
          this.$router.push({ name: 'administrador-lista-medidas' });
        })
        .catch(() => {
          this.makeToast(
            'Ops!',
            'Houve um problema para inserir, tente novamente em 5 minutos!',
            'danger'
          );
        })
        .finally(() => {
          setTimeout(() => {
            this.$store.dispatch('endLoader');
          });
        });
    },
    backList() {
      this.$router.push({
        name: 'administrador-lista-medidas',
      });
    },
  },
};
</script>

<style>
@import '../../custom/css/cria-dicas.css';
</style>
